export default "__VITE_ASSET__9c3546d7__"